import { GameId } from '@bg-shared/enums/GameId';
import { IMappedRunItemCallback } from '@bg-shared/business/CurrentResult/interfaces';
import { ICardGameRunItemShova52 } from '@bg-shared/business/CurrentResult/interfaces/ICardGameRunItemShova52';
import { Shova52DealtTo } from '@bg-shared/enums/Shova52DealtTo';
import { useCurrentResult } from './useCurrentResult';

const mapData: IMappedRunItemCallback<ICardGameRunItemShova52> = (entry) => {
    const item = entry.item as ICardGameRunItemShova52;

    return {
        item,
        order: item.dealtTo === Shova52DealtTo.DEALER ? item.position * 2 : item.position * 2 - 1,
    };
};

export const useCurrentShova52Result = (drawCode: string, delay = 0): ICardGameRunItemShova52[] =>
    useCurrentResult<ICardGameRunItemShova52>(GameId.SHOVA52, drawCode, delay, mapData, false);
